import { createFileRoute } from '@tanstack/react-router'
import { ClinicsPage } from '@/features/clinics'

export const Route = createFileRoute('/clinics')({
  component: ClinicsPage,
})
